import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const PILLARS = [
  {
    id: "strength",
    n: "01",
    title: "Strength",
    body: "Train with purpose. Personalised workouts designed around your goals, preferences, fitness level and individual needs.",
    img: "https://images.pexels.com/photos/15641820/pexels-photo-15641820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "A woman practicing a purposeful stretch on a yoga mat",
  },
  {
    id: "balance",
    n: "02",
    title: "Balance",
    body: "Create balance between mind and body through nutrition, sleep, hydration, mindfulness, meditation, recovery and everyday wellness habits.",
    img: "https://images.pexels.com/photos/28885889/pexels-photo-28885889.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Sliced fresh figs on white porcelain, symbolising nourishment",
  },
  {
    id: "self",
    n: "03",
    title: "Self",
    body: "Understand yourself better. Reflect, become more self-aware, gain clarity, and build a stronger relationship with yourself.",
    img: "https://images.pexels.com/photos/31755546/pexels-photo-31755546.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "A woman meditating peacefully outdoors with closed eyes",
  },
];

export const Pillars = () => (
  <section data-testid="pillars-section" className="bg-white/60 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: EASE }}
        className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-dark"
      >
        The three pillars
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
        className="mt-5 max-w-xl font-serif text-2xl leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl"
      >
        One experience, built on three foundations.
      </motion.h2>

      <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-12">
        {PILLARS.map((p, i) => (
          <motion.article
            key={p.id}
            id={p.id}
            data-testid={`pillar-card-${p.id}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: EASE }}
            className="group scroll-mt-28"
          >
            <div className="overflow-hidden rounded-[2rem]">
              <img
                src={p.img}
                alt={p.alt}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
              />
            </div>
            <div className="mt-7 flex items-start gap-5 px-1">
              <span className="font-serif text-4xl italic leading-none text-gold/45 transition-colors duration-500 group-hover:text-gold">
                {p.n}
              </span>
              <div>
                <h3 className="font-serif text-xl font-medium text-ink-soft transition-transform duration-500 group-hover:-translate-y-0.5 sm:text-2xl">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[#5C5450]">{p.body}</p>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
